package com.essntl.features.country.domain.usecase

import com.essntl.features.country.domain.model.CountryModel
import com.essntl.features.country.domain.repository.CountryRepository
import org.koin.core.annotation.Single

@Single
class AddEditCountryUseCase(
    private val countryRepository: CountryRepository,
) {
    private suspend fun performCountryCheck(
        country: CountryModel,
        call: suspend () -> Result<CountryModel>,
    ): Result<CountryModel> {
        val countryExists = countryRepository
            .getCountCountriesByName(country.name)
            .getOrNull()?.toInt()

        if (countryExists != 0)
            return Result.failure(Exception("This country is already added, please add a new one."))

        val response = call()

        return response
    }

    suspend fun insertCountry(
        country: CountryModel,
    ): Result<CountryModel> =
        performCountryCheck(country) {
            countryRepository.insert(country)
        }

    suspend fun updateCountry(
        country: CountryModel,
    ): Result<CountryModel> =
        performCountryCheck(country) {
            countryRepository.update(country)
        }
}